import script from "./PopoverTagItem.vue?vue&type=script&setup=true&lang=js"
export * from "./PopoverTagItem.vue?vue&type=script&setup=true&lang=js"

import "./PopoverTagItem.vue?vue&type=style&index=0&id=fe766a7e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fe766a7e"]])

export default __exports__